export const SERVICES = [
  {
    slug: "implementering",
    title: "Implementering",
    text: "Når traumebevidsthed skal forankres i organisationens praksis, relationer og rammer.",
  },
  {
    slug: "kurser",
    title: "Kurser og undervisning",
    text: "Viden og handlegreb til at styrke praksis",
  },
  {
    slug: "supervision",
    title: "Supervision og faglig sparring",
    text: "Et rum for refleksion, forståelse og udvikling af faglig praksis.",
  },
];
